import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AppSharedModule } from 'src/app/shared/shared.module';
import { AppBreadcrumbComponent } from './app.breadcrumb.component';

@NgModule({
    imports: [
        CommonModule,
        AppSharedModule
    ],
    declarations: [
        AppBreadcrumbComponent
    ],
    exports: [
        AppBreadcrumbComponent
    ]
})
export class AppBreadcrumbModule {
}

